import { render, staticRenderFns } from "./UpdateBankDataDialog.vue?vue&type=template&id=2850555e"
import script from "./UpdateBankDataDialog.vue?vue&type=script&lang=ts"
export * from "./UpdateBankDataDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports